import React from 'react';
import { Hero } from '../components/Hero';
import { Awareness } from '../components/Awareness';
import { About } from '../components/About';
import { WaysToWork } from '../components/WaysToWork';
import { FinalCTA } from '../components/FinalCTA';
export function Home() {
  return <>
      <Hero data-id="element-839" />
      <Awareness data-id="element-840" />
      <About data-id="element-841" />
      <WaysToWork data-id="element-842" />
      <FinalCTA data-id="element-843" />
    </>;
}